import { useTranslation } from "react-i18next";

type IPrps = {
  totalRows: number | null;
};

export default function ListHead({ totalRows }: IPrps) {
  const { t } = useTranslation();
  return (
    <div className="sub-head mb-[10px]">
      <ul className="">
        <li className="flex items-end gap-2">
          <h3>{t("txt_search_hst")}</h3>
          <span hidden={!totalRows} className="text-xs font-bold">
            {t("txt_search_result")}
            <strong className="text-red-400">
              &nbsp;{t("txt_total")} {totalRows}
            </strong>
          </span>
        </li>
      </ul>
    </div>
  );
}
